import React from 'react';
import { MDBBtn, MDBCarousel, MDBCarouselInner, MDBCarouselItem, MDBCol, MDBContainer, MDBRow, MDBTypography, MDBView } from 'mdbreact';
import { Language } from '../../redux/store/base/language';
import { useSelector } from 'react-redux';

// Import asset
import "./Comment.scss";

const Comment = (props: CommentProps) => {

    const dictionary = useSelector(
        (state: { lang: Language }) => state.lang.dictionary?.homepage
    );

    return <MDBRow middle center className="comment">
        <MDBCol sm="12" className="d-block m-auto">
            <h3 className="text-center mb-1">{dictionary?.comment_customer}</h3>
        </MDBCol>
        <MDBCol sm="12" md="9" className="mt-3">
            <MDBContainer>
                <MDBCarousel
                    activeItem={1}
                    length={3}
                    showControls={true}
                    showIndicators={false}
                // className="z-depth-1"
                >
                    <MDBCarouselInner>
                        <MDBCarouselItem itemId="1">
                            <MDBView>
                                <q>
                                    خدمة جميلة ومريحة جدا
                               </q>
                                <p>
                                    ريم الشهري
                                </p>
                            </MDBView>
                        </MDBCarouselItem>
                        <MDBCarouselItem itemId="2">
                            <MDBView>
                                <q>
                                    خدمة جميلة ومريحة جدا
                               </q>
                                <p>
                                    فاطمه راشد
                                </p>
                            </MDBView>
                        </MDBCarouselItem>
                        <MDBCarouselItem itemId="3">
                            <MDBView>
                                <q>
                                    خدمة جميلة ومريحة جدا
                               </q>
                                <p>
                                    هند محمد
                                </p>
                            </MDBView>
                        </MDBCarouselItem>
                    </MDBCarouselInner>
                </MDBCarousel>
            </MDBContainer>
        </MDBCol>
    </MDBRow>
};

interface CommentProps { }
export default Comment;